import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Inspection, InspectionSection } from '../../models/index';

@Component({
    selector: 'model-sections',
    templateUrl: './list.component.html',
    standalone: false
})
export class ModelSectionListComponent {
  @Input() public inspection: Inspection;
  @Output() public toggleSelectSection: EventEmitter<any> = new EventEmitter();
  public selectedSection: any;
  orderByFieldName: string = 'order';
  direction: string = 'asc';
  @Input() query: string = '';
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectSection(section: InspectionSection) {
    this.toggleSelectSection.emit(section);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName == newOrderBy ? (this.direction == 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
